export default __webpack_public_path__ + "static/2-8d97422160f8d775b457f95a8846baab.jpg";